import {
  ProjectExperiments,
  SessionExperiments,
  UserExperiments,
} from '../experiments';

export const sessionExperiments: Partial<SessionExperiments> = {
  'T140960-webapp-login-signup-v3': 'test',
  'T165052-webapp-home-page': 'test',
  'T194698-home-page-aa-test': 'control',
  'T207259-webapp-home-page-redesign-v3': 'control',
};

export const userExperiments: Partial<UserExperiments> = {
  'T111865-logged-in-pjp-live-chat-just-enrollment': 'control',
  'T198995-bid-card-redesign-v3': 'control',
  'T58186-giveget-delayed-payment-verify-v2': 'control',
  'T90189-image-thumbnail-service': 'control',
  'T151438-ga-fb-conversion-tracking-v1': 'control',
  'T183128-projects-amount-overview-on-dashboard': 'control',
  webapp_playground_test: 'control',
};
export const projectExperiments: Partial<ProjectExperiments> = {};

export const isWhitelistUser = false;

export const shouldEnrol = true;
